var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"posicion"},[_c('v-card',{attrs:{"id":"tarjetaPopUp"}},_vm._l((_vm.informacionFormulariosLlenos),function(formulario,index){return _c('div',{key:index,attrs:{"id":"contenedorFormulario"}},[_c('p',{style:([formulario.completado? {color:'#3DC4B9'}:{}]),attrs:{"id":"NombreFormulario"}},[_vm._v(_vm._s(formulario.nombre)+" "),(formulario.obligatorio)?_c('a',[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('img',{attrs:{"src":formulario.icono,"id":"imagenVerificacion"}})])}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e3e8a96","hasScoped":true,"buble":{"transforms":{}}}!./src/components/PopUp/popUp.html
// module id = 947
// module chunks = 0